var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_vm._l((_vm.items),function(item){return _c(_vm.resolveNavItemComponent(item),{key:item.header || item.title,tag:"component",attrs:{"item":item}})}),_c('vertical-nav-menu-link',{attrs:{"item":{
      title: 'Support&Complaints',
      resource: 'support-and-complaints',
      action: 'read',
      href: 'https://alsafeer.zendesk.com/'
    }}}),_c('vertical-nav-menu-link',{attrs:{"item":{
      title: 'Technical Support',
      href: 'https://safeer-it.atlassian.net/servicedesk/customer/portal/1'
    }}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }